import {configureStore} from "@reduxjs/toolkit";
import userDataSlice from "./slices/userDataSlice";
import currentEventSlice from "./slices/currentEventSlice";
import roomSlice from "./slices/roomSlice";
import feedbackSlice from "./slices/feedbackSlice";
import sensorSlice from "./slices/sensorSlice";
import buildingSlice from "./slices/buildingSlice";
import deviceSlice from "./slices/deviceSlice";
import uiControlSlice from "./slices/uiControlSlice";
// Store: a collection of slices
// Slice: a global state
// Reducer: a function (state, action) that changes a slice
// Selector: getters to a state
// Dispatch: to modify a state with actions
const store = configureStore({
  reducer: {
    userData: userDataSlice,
    currentEvents: currentEventSlice,
    room: roomSlice,
    feedback: feedbackSlice,
    sensor: sensorSlice,
    building: buildingSlice,
    device: deviceSlice,
    uiControl: uiControlSlice,
  },
});
// selectors
export const selectUserData = (state) => state.userData.data;
export const selectUserFullData = (state) => state.userData;
export const selectCurrentEvent = (state) => state.currentEvents.data;
export const selectRoom = (state) => state.room.data;
export const selectFeedback = (state) => state.feedback.data;
export const selectSensor = (state) => state.sensor.data;
export const selectBuilding = (state) => state.building.data;
export const selectDevice = (state) => state.device.data;
export const selectUiControl = (state) => state.uiControl;
export default store;
